import React from "react";
import Device from "./components/Device";

const OrgDevice=()=>{
    return (
        <Device></Device>

    )
}
export default OrgDevice